import { useEffect } from "react";

const trackEvent = (eventName, eventParams) => {
    if (process.env.NODE_ENV === "development") {
        console.log(`[DEBUG] Sending event: ${eventName}`, eventParams); // **イベント送信時のログ**
    }

    if (typeof window.gtag === "function") {
        window.gtag("event", eventName, eventParams);
    } else {
        console.warn("[ERROR] gtag が未定義のため、イベント送信できません");
    }
};

const useClickEventTracker = () => {
    useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            console.log("[DEBUG] ClickEventTracker initialized"); // **クリックイベント登録開始**
        }

        const addEventOnce = (element, eventType, handler) => {
            if (element && !element.dataset.eventRegistered) {
                element.addEventListener(eventType, handler, { once: true });
                element.dataset.eventRegistered = "true";
            }
        };

        const registerClickEvents = () => {
            // TELボタンの登録
            for (let i = 1; i <= 10; i++) {
                const telButton = document.getElementById(`tel_${i}`);
                if (telButton) {
                    addEventOnce(telButton, "click", () => {
                        trackEvent("tel_click", {
                            event_category: "TEL",
                            tel_event_label: `TEL_${i}`,
                            page_location: window.location.href
                        });
                    });
                }
            }

            // BOOKボタンの登録（←ここに追加）
            for (let i = 1; i <= 10; i++) {
                const bookButton = document.getElementById(`book_${i}`);
                if (bookButton) {
                    addEventOnce(bookButton, "click", (e) => {
                        if (process.env.NODE_ENV === "development") {
                            console.log(`[DEBUG] BOOK Button Clicked: BOOK_${i}`);
                        }
                        e.preventDefault();
                        trackEvent("book_click", {
                            event_category: "BOOK",
                            book_event_label: `BOOK_${i}`,
                            page_location: window.location.href
                        });
                        setTimeout(() => {
                            window.open(bookButton.href, "_blank", "noopener,noreferrer");
                        }, 300);
                    });
                }
            }

            // **その他ボタン**
            const categories = [
                { category: "BenefitsTEL", prefix: "benefits_tel" },
                { category: "BenefitsLINE", prefix: "benefits_line" },
                { category: "SNS", prefix: "sns" },
                { category: "Banner", prefix: "banner" }
            ];

            categories.forEach(({ category, prefix }) => {
                for (let i = 1; i <= 10; i++) {
                    const eventButton = document.getElementById(`${prefix}_${i}`);
                    if (eventButton) {
                        addEventOnce(eventButton, "click", () => {
                            trackEvent("button_click", {
                                event_category: category,
                                btn_event_label: `${prefix}_${i}`,
                                page_location: window.location.href
                            });
                        });
                    }
                }
            });
        };

        // ヘッダーメニュー登録
        const registerHeaderMenuEvents = () => {
            const headerMenuItems = document.querySelectorAll(".pcnav li a");
            headerMenuItems.forEach((item) => {
                const label = item.textContent?.trim() || "unknown";
                addEventOnce(item, "click", () => {
                    trackEvent("menu_click", {
                        event_category: "HeaderNav",
                        menu_event_label: `HeaderNav: ${label}`,
                        page_location: window.location.href
                    });
                });
            });
        };

        // フッターメニュー登録
        const registerFooterMenuEvents = () => {
            const footerItems = document.querySelectorAll("footer .navs li a");
            footerItems.forEach((item) => {
                const label = item.textContent?.trim() || "unknown";
                addEventOnce(item, "click", () => {
                    trackEvent("menu_click", {
                        event_category: "FooterNav",
                        menu_event_label: `FooterNav: ${label}`,
                        page_location: window.location.href
                    });
                });
            });
        };

        // SPメニュー登録
        const registerSpMenuEvents = () => {
            const spMenuItems = document.querySelectorAll(".wrapper.sp .link a");
            spMenuItems.forEach((item) => {
                const label = item.textContent?.trim() || "unknown";
                addEventOnce(item, "click", () => {
                    trackEvent("menu_click", {
                        event_category: "SPNav",
                        menu_event_label: `SPNav: ${label}`,
                        page_location: window.location.href
                    });
                });
            });
        };

        // 遅延実行で描画後にイベント登録
        setTimeout(() => {
            registerClickEvents();
            registerHeaderMenuEvents();
            registerFooterMenuEvents();
            registerSpMenuEvents();
        }, 500);
    }, []);
};

const ClickEventTracker = () => {
    useClickEventTracker();
    return null;
};

export { trackEvent, ClickEventTracker };